/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AppleOAuthDto = {
    /**
     * Apple identity token (JWT) received from Sign in with Apple
     */
    identity_token: string;
    /**
     * User full name (only provided by Apple on the very first sign-in). The mobile client MUST send this on initial registration; subsequent sign-ins will not have it.
     */
    full_name?: string;
    /**
     * Device type for token handling
     */
    device_type?: AppleOAuthDto.device_type;
    /**
     * FCM/APNs push notification token
     */
    device_token?: string;
    /**
     * Device name
     */
    device_name?: string;
};
export namespace AppleOAuthDto {
    /**
     * Device type for token handling
     */
    export enum device_type {
        IOS = 'ios',
        ANDROID = 'android',
        WEB = 'web',
    }
}

